export default __webpack_public_path__ + "static/media/blog01.1736f8c9.jpg";